export const StoreState = {
  didLogin:'didLogin'
}

export const state = {
  [StoreState.didLogin]:false
}
